export const DashboardDetailType = Object.freeze({
  ACTIVE_SAAS: 'ACTIVE_SAAS',
  INACTIVE_SAAS: 'INACTIVE_SAAS',
  ACTIVE_OUTLETS: 'ACTIVE_OUTLETS',
  INACTIVE_OUTLETS: 'INACTIVE_OUTLETS',
  ACTIVE_DEVICES: 'ACTIVE_DEVICES',
  INACTIVE_DEVICES: 'INACTIVE_DEVICES',
  POS_BILL_COUNT: 'POS_BILL_COUNT',
  POS_BILL_TOTAL: 'POS_BILL_TOTAL',
  DIGITAL_MENU_BILL_COUNT: 'DIGITAL_MENU_BILL_COUNT',
  DIGITAL_MENU_BILL_TOTAL: 'DIGITAL_MENU_BILL_TOTAL'
});

export const DashboardDetailIcon = Object.freeze({
  ACTIVE_SAAS: 'tabler:cloud-check',
  INACTIVE_SAAS: 'tabler:cloud-x',
  ACTIVE_OUTLETS: 'mdi:shop-check-outline',
  INACTIVE_OUTLETS: 'mdi:shop-delete-outline',
  ACTIVE_DEVICES: 'tabler:device-ipad-horizontal-check',
  INACTIVE_DEVICES: 'tabler:device-ipad-horizontal-x',
});